import { JSX, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@mui/material";
import { useCsConfigurationApi } from "@plansoft-configuration-renderer/framework";

interface IBtnConfigSearchProduct {
  sessionId: string;
  path: string;
}

export const BtnConfigSearchProduct = ({
  //sessionId,
  path,
}: IBtnConfigSearchProduct): JSX.Element => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { invokeUserDefinedFunction } = useCsConfigurationApi();
  const [status, setStatus] = useState<
    "init" | "default" | "error" | "success"
  >("init");

  const handleClick = async (): Promise<void> => {
    setStatus("default");
    setIsLoading(true);
    const outputSearchProduct = await invokeUserDefinedFunction({
      name: "searchProduct",
      input: JSON.stringify({}),
      path: path || "/",
    });
    console.log(`invokeUserDefinedFunction "searchProduct":`, {
      outputSearchProduct,
    });

    setIsLoading(false);
  };

  return (
    <Button
      onClick={handleClick}
      variant="contained"
      color={
        status === "success"
          ? "success"
          : status === "error"
            ? "error"
            : "primary"
      }
      loading={isLoading}
      loadingPosition="end"
    >
      {t("WEG:config.btn.searchProduct")}
    </Button>
  );
};
